<template>
  <PageLayoutWrapper
    page="departments/_id/courses"
    :props="{...$props, courses }"
  >
    <BaseTable
      :rows="courses"
      resource-name="Courses"
      @select="goToCourse"
    >
      <template #header>
        <th class="th">Code</th>
        <th class="th">Name</th>
        <th class="th">Description</th>
      </template>
      <template #default="{ row: course }">
        <td>
          <NuxtLink
            :to="getCourseUrl(course)"
            :aria-label="`Link to ${course.code || course.subjectCode + course.courseNumber || ''} course`"
          >
            {{ course.code || course.subjectCode + course.courseNumber }}
          </NuxtLink>
        </td>
        <td>
          {{ courseNameWithFallbacks(course) }}
        </td>
        <td>
          {{ getShortDescription(course.description) }}
        </td>
      </template>
    </BaseTable>
  </PageLayoutWrapper>
</template>

<script>
import _sortBy from 'lodash/sortBy'
import { getShortDescription, safeEncodeURIComponent } from '@/utils/generalUtils'
import PageLayoutWrapper from '@/components/PageLayoutWrapper'
import CoursesService from '@/services/courses'
import useCourses from '@/composables/useCourses'
import { courseNameWithFallbacks } from '@/utils/entityNames'
import { departmentRelatedCoursesFields } from '@/constants/departments'
import useMeta from '@/composables/useMeta'

export default {
  components: { PageLayoutWrapper },
  props: {
    department: {
      type: Object,
      required: true,
    },
    availableColumns: {
      type: Array,
      default: () => [
        {
          id: 'Code',
        },
        {
          id: 'Name',
        },
        {
          id: 'Description',
        },
      ],
    },
  },
  setup(props, { root }) {
    const { goToCourse, getCourseUrl } = useCourses(root)
    const { catalogWideMetaTitle } = useMeta()
    return {
      getCourseUrl,
      goToCourse,
      courseNameWithFallbacks,
      catalogWideMetaTitle,
    }
  },
  head() {
    return {
      title: `${this.department.displayName} Department Courses | ${
        this.catalogWideMetaTitle
      }`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${this.department.displayName} Department Courses | ${
            this.catalogWideMetaTitle
          }`,
        },
      ],
    }
  },
  async asyncData({ params, $bugsnag, $axios, redirect, store }) {
    const api = new CoursesService($axios, store)
    // Context: https://www.notion.so/coursedog1/CA-23417-CUNY-Catalogs-are-not-displaying-value-in-customize-columns-under-Department-department-17ef804589d18069b1b6fc723d2787ef
    const isCUNY = store.getters['settings/layout'] === 'cuny'

    try {
      const { data } = await api.getCourses({
        department: safeEncodeURIComponent(params.id),
        columns: [...departmentRelatedCoursesFields,
          ...(isCUNY ? [
            'customFields.catalogRequirementDesignation',
            'customFields.catalogAttributes',
          ] : []),
        ],
      })
      let courses = data
      courses = _sortBy(Object.values(courses), ['code', 'name', 'longName'])

      return { courses }
    } catch (e) {
      console.error(e)
      $bugsnag.notify(e)
      redirect('/404')
    }
  },
  methods: {
    getShortDescription,
  },
}
</script>
